import { DataTable, Dialog, Heading, Loader } from "@/components";
import { Button, Input } from "@/components/ui";
import useHelpDocument from "./useHelpDocument";
import { Search } from "lucide-react";


const HelpDocument = () => {
  const {
    onAdd,
    isMobile,
    globalFilter,
    setGlobalFilter,
    columns,
    isLoadingHelpDocuments,
    helpDocuments,
    isOwner,
    onRowClick,
    hasAddPermission,
    openDeleteDialog,
    setOpenDeleteDialog,
    selectedRow,
    isDeleteDocumentPending,
    onDeleteConfirm
  } = useHelpDocument();

  return (
    <div className="p-4 md:p-6">
      <div className="flex flex-col lg:flex-row gap-2 lg:items-center lg:justify-between mb-6">
        <div className="flex flex-row items-center justify-between">
          <Heading title="Help Document" />
          {!isOwner && isMobile && hasAddPermission && (
            <Button onClick={onAdd} className="px-2">
              + Add Document
            </Button>
          )}
        </div>

        <div className="flex flex-row items-center gap-4">
          <Input
            type="text"
            placeholder="Search"
            value={globalFilter ?? ""}
            onChange={(e) => setGlobalFilter(e.target.value)}
            className="w-full sm:w-72 bg-white h-[40px]"
            startIcon={<Search className="w-4 h-4" />}
          />

          {!isOwner && !isMobile && hasAddPermission && (
            <Button onClick={onAdd}>+ Add Help Document</Button>
          )}
        </div>
      </div>

      {/* Table */}
      {isLoadingHelpDocuments ? (
        <Loader />
      ) : (
        <>
          <DataTable
            columns={columns}
            data={helpDocuments?.data?.sort(
              (a: any, b: any) =>
                new Date(b.createdAt).getTime() -
                new Date(a.createdAt).getTime()
            ) || []}
            setGlobalFilter={setGlobalFilter}
            globalFilter={globalFilter}
            onRowClick={onRowClick}
          />
        </>
      )}
      <Dialog
        open={openDeleteDialog}
        setOpen={setOpenDeleteDialog} 
        title={<div className="text-2xl font-bold text-primary">
          {"Confirmation"}
          <div className="h-1 w-[30%] bg-primary rounded-full" />
        </div>}
        saveText="Delete"
        saveBtnClassName="bg-red-500 text-white hover:bg-red-500 hover:text-white"
        isLoading={isDeleteDocumentPending}
        onSave={onDeleteConfirm}
      >
        <p className="text-sm">
          Are you sure you want to delete selected help document -{" "}
          <span className="font-bold text-primary">
            {(selectedRow as any)?.attachment?.originalFileName}
          </span>
          ?
        </p>
      </Dialog>
    </div>
  );
};

export default HelpDocument;
